// @internal
export function isNil(v) {
    return v === null || v === undefined;
}
//# sourceMappingURL=isNil.js.map